import axiosInstance from '../RestClient';

const BASE_URI = '/bills';
class BilllService {
	async list() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	/**
	 * Updates a single generated bill only — never its BillTemplate, and no
	 * backfill. `edit` (PUT /bills/:id) rewrites the whole recurring gasto when
	 * the bill is Periodico, so it can't serve a per-bill edit.
	 */
	async editInstance(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}/instance`, payload);
		return response;
	}

	async getBillTemplate(templateId) {
		const response = await axiosInstance.get(`${BASE_URI}/templates/${templateId}`);
		return response;
	}

	async editTemplate(templateId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/templates/${templateId}`, payload);
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}

	async delete(recordId, stopBillGeneration) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri,{
			data: { stopBillGeneration },
		});
		return response;
	}

	async listBillsForAccount(accountId) {
		const uri = `${BASE_URI}/mine/${accountId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listBillsForAsset(assetId) {
		const uri = `${BASE_URI}/mineasset/${assetId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async uploadComprobante(formData) {
		const uri = `${BASE_URI}/uploadComprobante`;
		const response = await axiosInstance.post(uri, formData, { headers: { 'Content-Type': undefined } });
		return response;
	}

	async confirmBilllPayment(billId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/confirmarPago/${billId}`, payload);
		return response;
	}

	async deleteBilllsForAsset(assetId) {
		const uri = `${BASE_URI}/mineAsset/${assetId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	async deactivateBillTemplate(templateId) {
		const uri = `/bills/templates/${templateId}/deactivate`;
		const response = await axiosInstance.put(uri);
		return response;
	}
	async activate(templateId) {
		const uri = `/bills/templates/${templateId}/activate`;
		const response = await axiosInstance.put(uri);
		return response;
	}

	async search(queryParams) {
		const uri = `${BASE_URI}/search?${queryParams}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getWithDocuments() {
		const uri = `${BASE_URI}/withDocuments`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async updateExpiration(billId, expirationDate) {
		const uri = `${BASE_URI}/${billId}/expiration`;
		const response = await axiosInstance.put(uri, { expirationDate });
		return response;
	}
}
export default new BilllService();
